import { agencyJaneOrderValidationQueryConfig } from 'components/ShiftModal/src/views/AssignToAgencyTeamMemberView/contexts/context.constants';
import { useGQLQuery } from 'hooks';
import { UseGQLQuery } from 'hooks/useGQLQuery/useGQLQuery.types';
import { FC, useContext } from 'react';
import {
  AssignToAgencyTeamMemberFetchAgencyJaneAvailabilityByJaneIdOrderIdQuery,
  AssignToAgencyTeamMemberFetchAgencyJaneAvailabilityByJaneIdOrderIdQueryVariables,
} from 'types/graphql';
import { createGQLDataContext } from 'utils/createDataContext';

export const FetchAgencyTeamMemberAvailabilityByOrderIdDataContext = createGQLDataContext<
  UseGQLQuery<AssignToAgencyTeamMemberFetchAgencyJaneAvailabilityByJaneIdOrderIdQuery>
>({} as UseGQLQuery<AssignToAgencyTeamMemberFetchAgencyJaneAvailabilityByJaneIdOrderIdQuery>);

export const FetchAgencyTeamMemberAvailabilityByOrderIdDataProvider: FC<{
  janeId: string;
  orderId: number;
  orderRelayId: string;
  breakTime?: string;
  onSuccess: (
    data: AssignToAgencyTeamMemberFetchAgencyJaneAvailabilityByJaneIdOrderIdQuery,
  ) => void;
}> = ({ children, janeId, orderId, orderRelayId, breakTime, onSuccess }) => {
  const { fetch, ...rest } = useGQLQuery<
    AssignToAgencyTeamMemberFetchAgencyJaneAvailabilityByJaneIdOrderIdQuery,
    AssignToAgencyTeamMemberFetchAgencyJaneAvailabilityByJaneIdOrderIdQuery,
    AssignToAgencyTeamMemberFetchAgencyJaneAvailabilityByJaneIdOrderIdQueryVariables
  >(agencyJaneOrderValidationQueryConfig({ janeId, orderId, orderRelayId, breakTime, onSuccess }));

  return (
    <FetchAgencyTeamMemberAvailabilityByOrderIdDataContext.Provider value={{ fetch, ...rest }}>
      {children}
    </FetchAgencyTeamMemberAvailabilityByOrderIdDataContext.Provider>
  );
};

export const useFetchAgencyTeamMemberAvailabilityByOrderIdDataContext =
  (): UseGQLQuery<AssignToAgencyTeamMemberFetchAgencyJaneAvailabilityByJaneIdOrderIdQuery> =>
    useContext(FetchAgencyTeamMemberAvailabilityByOrderIdDataContext);
